import { axiosClient } from '@/api/http/axios-client';
import type {
  ActiveConnection,
  FirestoreDatabasesResponse,
  GcpProjectsResponse,
  SetActiveConnectionParams,
} from './gcp.interface';

async function getActiveConnection(): Promise<ActiveConnection | null> {
  const { data } = await axiosClient.get<ActiveConnection | null>('/gcp/active-connection');
  return data;
}

async function setActiveConnection(body: SetActiveConnectionParams): Promise<ActiveConnection> {
  const { data } = await axiosClient.post<ActiveConnection>('/gcp/active-connection', body);
  return data;
}

async function clearActiveConnection(): Promise<void> {
  await axiosClient.delete('/gcp/active-connection');
}

async function getProjects(): Promise<GcpProjectsResponse> {
  const { data } = await axiosClient.get<GcpProjectsResponse>('/gcp/projects');
  return data;
}

async function getFirestoreDatabases(projectId: string): Promise<FirestoreDatabasesResponse> {
  const { data } = await axiosClient.get<FirestoreDatabasesResponse>(
    `/gcp/projects/${projectId}/firestore/databases`
  );
  return data;
}

export const GcpApi = {
  getActiveConnection,
  setActiveConnection,
  clearActiveConnection,
  getProjects,
  getFirestoreDatabases,
};
